import React,{useState,useEffect} from 'react'
import {Box } from 'grommet'
import { withRouter } from 'react-router-dom';
import EditCommdityForm from '../../../components/editCommodityForm'
import { API,Auth } from 'aws-amplify';
import { NavigationSnackBar,LoadLayer } from '../../../components/utils/shared/shared';
import { uploadToS3Doc,handleDocsChange,APIRequest } from '../../../components/utils/shared/requests';

function EditCommodity (props) {
  const [commodity, setCommodity] = useState();
  const [load, setLoad] = useState(true); 
  const [documents, setDocuments] = useState()
  const [labs, setLabs] = useState()
  const [lab, setLab] = useState()
  useEffect(() => { 
    APIRequest(`/commodities/${props.match.params.commodity_id}`).then(result => {setCommodity(result); setLab(result.owner_name);})
    APIRequest('/labs').then(result => {setLabs(result);setLoad(false)})
  },[]);
    const handleSubmit = () => {
        setLoad(true)
        if (documents != null){
          const s3Key = uploadToS3Doc(documents)
          commodity.documents_key = s3Key
        }
        Auth.currentSession().then(session => {
          API
          .put("LabShip", `/commodities/${commodity.id}`,
          { headers: { 
            Authorization: session.idToken.jwtToken,
          }, 
          body:{commodity: commodity}}).then(shipment => {
            setLoad(false)
            props.history.push({pathname: '/admin/commodities/all', edit: true, commSucc: true})
         })
        })
      }

    const setOwner = (event) => {
        var curr_commodity = commodity
        curr_commodity.lab_owner_id = event.value.id
        setCommodity(curr_commodity)
        setLab(event.value)
      }
  return (
   <Box margin='small'>
       {(load ? <LoadLayer load={load} label={'Loading Commodity...'} />: 
       <Box>
        <NavigationSnackBar title={`Edit Commodity: ${commodity.display_name}`} user={props.user} pages={[{name: 'Dashboard',link: '/dashboard'},{name: 'Commodities', link: '/commodities/all'}, {name: `Edit Commodity: ${commodity.display_name}`}]}  />
          <Box alignSelf='center' elevation='large' direction='column' margin='small' round width='xxlarge'>    
            <EditCommdityForm lab={lab} labs={labs} setLabs={setLabs} setOwner={setOwner} commodity={commodity} load={load} handleSubmit={handleSubmit} setCommodity={setCommodity} handleDocsChange={handleDocsChange} setDocuments={setDocuments} />
          </Box>
      </Box>
       )}
   </Box>
  )
}

export default withRouter(EditCommodity)
